import React from 'react'
import { Icon } from 'semantic-ui-react'

import { mergeStyles } from '@enlyt/helpers/mergeStyles'

import themeStyles from './styles'
import { useTheme } from 'contexts/ThemeProvider'

const CarouselDotGroup = props => {
  const { theme } = useTheme()
  const defaultStyles = themeStyles(theme)
  const styles = mergeStyles(defaultStyles, props.style)

  return (
    <div style={styles.container}>
      <div
        style={{
          ...styles.carouselContainer,
          ...(props.slidesCount === 1 && styles.oneDotCarouselContainer)
        }}
      >
        {props.slidesCount > 1 && (
          <button
            type='button'
            onClick={() => props.onClick(props.indexSelected - 1)}
            style={styles.button}
            aria-label='previous'
            disabled={props.indexSelected === 0}
          >
            <Icon
              name='chevron left'
              color={props.indexSelected === 0 ? 'grey' : undefined}
              style={styles.icon}
            />
          </button>
        )}
        <div style={styles.dotContainer}>
          {[...Array(props.slidesCount).keys()].map(slide => (
            <button
              type='button'
              tabIndex={-1}
              key={slide}
              onClick={() => props.onClick(slide)}
              style={
                props.indexSelected === slide ? styles.dotSelected : styles.dot
              }
              aria-label={`slide ${slide + 1}`}
            />
          ))}
        </div>
        {props.slidesCount > 1 && (
          <button
            type='button'
            onClick={() => props.onClick(props.indexSelected + 1)}
            style={styles.button}
            aria-label='next'
            disabled={props.indexSelected === props.slidesCount - 1}
          >
            <Icon
              name='chevron right'
              color={
                props.indexSelected === props.slidesCount - 1
                  ? 'grey'
                  : undefined
              }
              style={styles.icon}
            />
          </button>
        )}
      </div>
    </div>
  )
}

export default CarouselDotGroup
